"use client";

import { Check, MessageCircle, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Manuel Sánchez",
  location: "Totana, Murcia",
  rating: 5,
  quote: "Excelente servicio de detección de fugas. Llegaron con rapidez y solucionaron el problema en mi vivienda sin realizar romper innecesariamente. Muy profesionales y limpios.",
  verifiedText: "Cliente verificado"
}, {
  id: 2,
  name: "Carmen R. Lorca",
  location: "Comunidad de Propietarios, Murcia",
  rating: 5,
  quote: "Contratamos el mantenimiento de fontanería y climatización para la urbanización. La respuesta en urgencias es impecable y la atención inmejorable.",
  verifiedText: "Cliente verificado"
}, {
  id: 3,
  name: "David K.",
  location: "Puerto de Mazarrón",
  rating: 5,
  quote: "Great professional service! They communicated clearly in English, arrived on time, and fixed our pool leak quickly at a very fair price. Highly recommended.",
  verifiedText: "Cliente verificado"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section id="placeholdertestimonialsgrid" className="bg-background py-20 px-4 sm:px-6 lg:px-8 text-foreground transition-opacity duration-700">
      <div ref={ref} className={`mx-auto max-w-7xl transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex flex-col items-center text-center space-y-4 mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-[var(--chart-1)]/10 text-[var(--chart-1)] text-xs sm:text-sm font-semibold tracking-wider uppercase">
            <Check className="size-4" />
            <span>Valoraciones Reales</span>
            <Check className="size-4" />
          </div>

          <h2 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground">
            Opiniones de nuestros clientes
          </h2>

          <p className="font-default text-muted-foreground max-w-2xl text-base sm:text-lg">
            La confianza de los propietarios, empresas y comunidades en Totana y la Región de Murcia es nuestra mayor garantía.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((item, i) => <Card key={item.id} data-index={i} className="bg-[var(--card)] border border-dashed border-[var(--border)] shadow-xs hover:shadow-md transition-shadow flex flex-col justify-between rounded-xl">
              <CardHeader className="pt-6 pb-2">
                <div className="flex items-center space-x-1" aria-label={`Calificación ${item.rating} de 5 estrellas`}>
                  {Array.from({
                length: item.rating
              }).map((_, starIndex) => <Star key={starIndex} className="size-4 text-[var(--chart-1)] fill-[var(--chart-1)]/20" />)}
                </div>
              </CardHeader>

              <CardContent className="pt-2 pb-6">
                <p className="font-default italic text-foreground/90 text-sm sm:text-base leading-relaxed">
                  "{item.quote}"
                </p>
              </CardContent>

              <div className="px-6">
                <Separator />
              </div>

              <CardFooter className="pt-4 pb-6 flex items-center justify-between">
                <div>
                  <p className="font-default font-semibold text-sm text-foreground">
                    {item.name}
                  </p>
                  <p className="font-default text-xs text-muted-foreground">
                    {item.location}
                  </p>
                </div>
                <div className="flex items-center gap-1 text-xs font-medium text-[var(--chart-1)] bg-[var(--chart-1)]/10 px-2.5 py-1 rounded-lg">
                  <Check className="size-3" />
                  <span>{item.verifiedText}</span>
                </div>
              </CardFooter>
            </Card>)}
        </div>

        {}
        <div className="mt-14 text-center">
          <Button asChild size="lg" className="rounded-lg bg-[var(--chart-1)] hover:bg-[var(--chart-5)] text-primary-foreground font-medium px-8 py-6 text-base shadow-sm transition-all">
            <Link to="/ContactPage">
              <MessageCircle className="size-5 mr-2" />
              Consulta con nosotros por WhatsApp
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}